"use client"

import { useState } from "react";
import styles from "./styles/info.module.css";
import { useLanguage } from "@/context/LanguageContext";

export default function StaticInfo({ info }) {
  const { t } = useLanguage();
  const [activeIndex, setActiveIndex] = useState(0);

  const toRoman = (num) => {
    const romanMap = [
      [1000, "M"], [900, "CM"], [500, "D"], [400, "CD"],
      [100, "C"], [90, "XC"], [50, "L"], [40, "XL"],
      [10, "X"], [9, "IX"], [5, "V"], [4, "IV"], [1, "I"],
    ];
    return romanMap.reduce((acc, [value, numeral]) => {
      while (num >= value) {
        acc += numeral;
        num -= value;
      }
      return acc;
    }, "");
  };

  const handleClick = (index) => {
    setActiveIndex(index);
    const anchor = document.getElementById(info[index].link);
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className={styles.tableOfContents}>
      <h2>{t("about_us.table_of_contents")}</h2>

      {/* Desktop List */}
      <ul className={styles.desktopList}>
        {info.map((item, index) => (
          <li
            key={index}
            className={index === activeIndex ? styles.active : ""}
            onClick={() => handleClick(index)}
          >
            <a href={`#${item.link}`}>
              <span>{toRoman(index + 1)}.</span> {item.title}
            </a>
            <span className={styles.halfSlice}></span>
          </li>
        ))}
      </ul>

      {/* Mobile Select */}
      <select
        className={styles.mobileSelect}
        value={activeIndex}
        onChange={(e) => handleClick(Number(e.target.value))}
      >
        {info.map((item, index) => (
          <option key={index} value={index}>
            {toRoman(index + 1)}. {item.title}
          </option>
        ))}
      </select>
    </div>
  );
}